import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from './contexts/AuthContext';
import { LanguageProvider } from './contexts/LanguageContext';
import { Toaster } from './components/ui/sonner';
import LandingPage from './pages/LandingPage';
import AuthPage from './pages/AuthPage';
import DashboardPage from './pages/DashboardPage';
import BookingPage from './pages/BookingPage';
import AdminPage from './pages/AdminPage';
import ConfirmAppointmentPage from './pages/ConfirmAppointmentPage';
import AcceptModificationPage from './pages/AcceptModificationPage';
import PaymentPage from './pages/PaymentPage';
import './App.css';

function App() {
  return (
    <BrowserRouter>
      <LanguageProvider>
        <AuthProvider>
          <div className="App">
            <Routes>
              <Route path="/" element={<LandingPage />} />
              <Route path="/auth" element={<AuthPage />} />
              <Route path="/dashboard" element={<DashboardPage />} />
              <Route path="/booking" element={<BookingPage />} />
              <Route path="/admin" element={<AdminPage />} />
              <Route path="/confirm-appointment/:token" element={<ConfirmAppointmentPage />} />
              <Route path="/accept-modification/:token" element={<AcceptModificationPage />} />
              <Route path="/pay/:token" element={<PaymentPage />} />
              <Route path="*" element={<Navigate to="/" replace />} />
            </Routes>
            <Toaster position="top-right" />
          </div>
        </AuthProvider>
      </LanguageProvider>
    </BrowserRouter>
  );
}

export default App;
